import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { PhameeService } from 'src/app/services/phamee.service';
declare const $:any;

@Component({
  selector: 'smart-manage-thing-list',
  templateUrl: './manage-thing-list.component.html',
  styleUrls: ['./manage-thing-list.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingListComponent implements OnInit {
  form: FormGroup;
  successDelModal: string = '#successDelModal';
  successCountModal: string = '#successCountModal';
  successModal: string = '#successModal';
  errorModal: string = '#errorModal';
  farm_name: string = '';

  loadFarm: boolean = false;
  farmList = [];
  plotList = [];

  thingListAll  = [];
  thingList = [];
  sensorList = [];

  thingInfo = null;
  createThing = null;
  updateThing = null;
  updateSensor = null;
  deleteThing = null;
  loadFilter: boolean = false;

  numberOfSuccess: number = 0;
  limit: number = 10;
  page: number = 1;
  total: number;
  constructor(
    private formBuilder: FormBuilder,
    private PhameeService: PhameeService,
    private FarmService: FarmService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getFarmList();
  }

  createForm(){
    this.form = this.formBuilder.group({
      farm_id: [""],
      farm_info: [""],
      plot_id: [""],
      thing_name: [""]
    });

    this.form.controls.farm_id.valueChanges.subscribe(
      (value) => {

        if(value){
          if(value != this.form.value.farm_id){
            let farm = this.farmList.find(farm => farm._id == value);

            this.FarmService.getFarmByName(farm.name).subscribe(res=>{
              this.form.get("farm_info").setValue(res.data[0]);
            })

            this.getPlotList(value);
          }
        }
      }
    );
  }

  getFarmList(){
    this.spinner.show();
    this.PhameeService.getDropdownDashboard().subscribe(res=>{
    
      this.farmList = res.data.FarmList;

      if(this.farmList.length > 0 && !this.loadFilter){
        this.form.get('farm_id').setValue(this.farmList[0]._id);
      }
      this.spinner.hide();
    })
  }

  getPlotList(farm_id){
    this.spinner.show();
    this.PhameeService.getPlotDashboard(farm_id).subscribe(plot=>{

      this.plotList = plot.data.plot;

      if(this.plotList.length > 0){
        this.form.get('plot_id').setValue(this.plotList[0]._id);

        if(!this.loadFilter){
          this.search();
        }

        this.loadFilter = true;
      }
      this.spinner.hide();
    })
  }

  getThingList(farm_id, plot_id){
    this.spinner.show();

    this.FarmService.getThingMenuById(farm_id, plot_id).subscribe(thing=>{
      this.thingListAll = thing.data
      this.thingList = thing.data;

      this.getSensorList();

      this.spinner.hide();
    })
  }

  getSensorList(){
    this.sensorList = [];
  
    this.thingList.map(thing=>{
      if(thing.sensor.length > 0){

        thing.sensor.sort(function(a, b) {
          return a.order_by - b.order_by;
        }).map(sensor=>{
          this.sensorList.push(
            {
              ...sensor,
              thing_name: thing.thing_name
            }
          )
        });
      }
      if(thing.control.length > 0){
        thing.control.sort(function(a, b) {
          return a.order_by - b.order_by;
        }).map(sensor=>{
          this.sensorList.push(
            {
              ...sensor,
              thing_name: thing.thing_name
            }
          )
        });
      }
    })
  }

  search(){
    if(this.form.value.farm_id && this.form.value.plot_id){
      this.getThingList(this.form.value.farm_id, this.form.value.plot_id);
    }
  }

  reload(){
    window.location.reload();
  }

  searchThing(){
    this.spinner.show();
    if(this.form.value.thing_name){
      this.thingList = this.thingListAll.filter(thing=> thing.thing_name.includes(this.form.value.thing_name));

      this.getSensorList();

      this.spinner.hide();
    }else{
      if(this.form.value.farm_id && this.form.value.plot_id){
        this.getThingList(this.form.value.farm_id, this.form.value.plot_id);
      }

      this.spinner.hide();
    }
    if(this.sensorList.length > 0){
      this.page = 1;
    }
  }

  updateThingInfo(thing){
    this.updateThing = thing;
  }

  viewThingInfo(thing){
    this.thingInfo = thing;
  }

  getFarmName(farm_id){
    let farm = this.farmList.find(farm=> farm._id == farm_id);
    return farm.name;
  }

  saveSensor(e){
    if(e){
      this.FarmService.getAllSensorByThingsID(e.ThingId, this.form.value.plot_id).subscribe(res=>{
        let sensors = res.data || [];
        let number = 0;
        for(let i = 0; i< e.SensorInfo.length; i++){

          if(!sensors.find(sensor=> sensor.sensor_id == e.SensorInfo[i].SensorKey)){
            number = number + 1;
          }
        }
        if(number > 0){
          this.createThing = e;

          this.search();
          
          $(`#manage-thing-sensor-create`).modal("show");
        }else{
          $(this.successModal).modal("show");

          this.createThing = null;
          this.updateThing = null;
        }
      });
    }else{
      this.createThing = null;
      this.updateThing = null;
    }
  }

  editSensor(e){
    if((typeof e === "number") && Math.floor(e) === e){

      this.numberOfSuccess = e;

      $(this.successCountModal).modal("show");

      this.createThing = null;
      this.updateSensor = null;

    }else{
      if(e){

        $(this.successModal).modal("show");
  
        this.createThing = null;
        this.updateSensor = null;
      }else{
        this.createThing = null;
        this.updateSensor = null;
      }
    }
  }

  updateSensorInfo(sensor){
    this.updateSensor = sensor;
  }

  getPages(pageNo) {
    this.page = pageNo
  }

  toggleStatus(sensor){
    let data = {
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      thing_id: sensor.thing_id,
      thing_key: sensor.thing_key,
      farm_id: sensor.farm_id,
      plot_id: sensor.plot_id,
      sensor_bottom_border: sensor.sensor_bottom_border.toString(),
      sensor_top_border: sensor.sensor_top_border.toString(),
      sensor_id: sensor.sensor_id,
      sensor_img: sensor.sensor_img? sensor.sensor_img: "null",
      sensor_max: sensor.sensor_max.toString(),
      sensor_min: sensor.sensor_min.toString(),
      sensor_name: sensor.sensor_name,
      sensor_type: sensor.sensor_type,
      sensor_unit: sensor.sensor_unit? sensor.sensor_unit: "null",
      sensor_desc: sensor.sensor_desc,
      type: sensor.type,
      coordinates: sensor.coordinates,
      _id: sensor._id,
      active: sensor.active? "false": "true",
      sensor_widget_staus: sensor.active? "N": "Y",
      order_by: sensor.order_by,
      color: sensor.color,
      default: sensor.default,
      sensor_graph_staus: sensor.sensor_graph_staus,
      sensor_target_relay: sensor.sensor_target_relay,
      sensor_target_value: sensor.sensor_target_value,
      sensor_target_color: sensor.sensor_target_color
    }
    this.FarmService.updateSensor(data).subscribe(res=>{
      if(res.code == 200){
       this.editSensor(true);
      }
    })
  }
  deleteThingModal(thing){
    this.deleteThing = thing;
  }

  delThingInfo(){
    if(this.deleteThing){
      this.FarmService.deleteThing(this.deleteThing._id, this.form.value.plot_id).subscribe(res=>{
        if(res.code == 200){

          this.deleteThing = null;
          $(`${this.successDelModal}`).modal("show");
        }else{
          $(`${this.errorModal}`).modal("show");
        }
      })
    }
  }
}
